module.exports = __webpack_public_path__ + "img/lesson.de747042.svg";